import { defaultTo } from "lodash-es";

import type { DiscographyQueryType } from "@/types/discography";
import type { AlbumType } from "@garimpa/lib/albumTypes";

export type DiscographyTypeFilter = AlbumType | "all";
export type DiscographyEmptyReason = "none" | "filtered" | "empty";

export function resolveDiscographyViewState(input: {
  discographyQueryType: DiscographyQueryType;
  effectiveType: DiscographyTypeFilter | undefined;
  typeCounts: Record<DiscographyTypeFilter, number>;
  typeCountsLoaded: boolean;
  albumCount: number;
  isLoading: boolean;
  hasFacetFilters: boolean;
  searchValue: string;
}) {
  const selectedType =
    input.discographyQueryType === "auto"
      ? defaultTo(input.effectiveType, "all")
      : input.discographyQueryType;
  const hasSearch = input.searchValue.trim().length > 0;
  const hasActiveFilters = [
    input.discographyQueryType !== "auto",
    input.hasFacetFilters,
    hasSearch,
  ].some(Boolean);
  const hasNarrowingFilters = [input.hasFacetFilters, hasSearch].some(Boolean);
  const selectedTypeCount =
    selectedType === "all" ? input.typeCounts.all : defaultTo(input.typeCounts[selectedType], 0);
  const noAlbums = input.albumCount === 0;
  const loaded = !input.isLoading;
  const emptyReason: DiscographyEmptyReason = [
    loaded,
    noAlbums,
    input.typeCountsLoaded,
    input.typeCounts.all === 0,
    !hasActiveFilters,
  ].every(Boolean)
    ? "empty"
    : [loaded, noAlbums, hasNarrowingFilters, selectedTypeCount > 0].every(Boolean)
      ? "filtered"
      : "none";

  return {
    emptyReason,
    hasActiveFilters,
    isTypeResolved: [input.discographyQueryType !== "auto", input.effectiveType !== undefined].some(
      Boolean,
    ),
    selectedType,
  };
}
